import React, { useState, useEffect } from 'react';
import SideMenuBar from '../../components/sideMenuBar';
import { useNavigate } from 'react-router-dom';
import { ACTIONS, KEYS, URLS } from '../../_config';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import Icon from '../../components/icons';
import Filter from '../../components/filter';
import { useStoreApi } from '../../store/api/hooks/storeApiHook';
import toast from 'react-hot-toast';
import Spinner from '../../components/iconSvgs/spinner';
import { allowOnlyNumbers } from '../../_common/functions';
import { ActivetabProps } from '../../_config/interfaces/interfaces';

const StoreInformation: React.FC<ActivetabProps> = ({ activeTab }) => {
    const [isDivVisible, setIsDivVisible] = useState(false);
    const [isOnSubmitLoading, setOnSubmitLoading] = React.useState<boolean>(false);
    const [storeData, setStoreData] = useState<any>(null);
    const [filterValue, setFilterValue] = useState<any>({});

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const storeAPI: any = useStoreApi();

    const { register, formState: { errors }, handleSubmit, setValue } = useForm<any>();
    
    useEffect(() => {
        getStores();
    }, []);

    const getStores = () => {
        storeAPI.getStore({}, (msg: any, resp: any) => {
            if (resp?.data) {
                dispatch({
                    type: ACTIONS.STORE.GET_STORE,
                    payload: resp.data,
                });
                setStoreData(resp.data);
                setValue("storeName", resp.data.name);
                setValue("storeBrnLimit", resp.data.branch_limit ? resp.data.branch_limit : 0);
            }
        }, (error: any, resp: any) => {
            console.log('error =>', error);
        })
    }

    const handleApplyFilter = (filterData: any) => {
        setFilterValue(filterData);
    };

    const handleClearFilter = () => {
        setFilterValue(null);
    };

    const onSubmit = (data: any) => {
        setOnSubmitLoading(true);
        const param = {
            new_name: data.storeName,
            branch_limit: data.storeBrnLimit,
        }

        try {
            setTimeout(() => {
                storeAPI.updateStoreInfo(param, (msg: any, resp: any) => {
                    if (resp?.code === 201 || resp?.code === 200) {
                        toast.success(resp?.message);
                        dispatch({
                            type: ACTIONS.STORE.GET_STORE,
                            payload: resp.data,
                        });
                    } else {
                        toast.error(resp?.message);
                    }
                }, (error: any, resp: any) => {
                    console.log('error =>', error, resp);
                    if (resp?.detail?.code === 400) {
                    } else {
                        toast.error("Something went wrong");
                    }
                });
                setOnSubmitLoading(false);
            }, 5000)
        } catch (e) {
            // console.log('error =>', e);
            setOnSubmitLoading(false);
        }
    };


    return (
        <>
            {isOnSubmitLoading && (
                <div className="absolute inset-0 bg-gray-700 bg-opacity-50 flex justify-center items-center z-50">
                    <Spinner className="self-center z-50" />
                </div>
            )}
            <div className="mt-6">
                <h2 className="text-gray-700 text-lg font-semibold mb-6">Store Information</h2>

                <form onSubmit={handleSubmit(onSubmit)} className="space-y-5 max-w-lg">
                    {/* Store Name */}
                    <div>
                        <label className="block text-sm font-medium text-gray-600 mb-1">Store Name</label>
                        <div className="relative">
                            <input
                                type="text"
                                {...register("storeName", { required: true })}
                                placeholder="Enter store name"
                                autoComplete="off"
                                className={`w-full rounded-md bg-white px-3 py-2 pr-10 text-sm text-gray-800 border ${errors.storeName ? 'border-red-400' : 'border-gray-300'} placeholder:text-gray-400 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition`}
                            />
                            <Icon name="store" size={18} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" />
                        </div>
                        {errors.storeName && <p className="mt-1 text-xs text-red-500">Store name is required</p>}
                    </div>

                    {/* Branch Limit */}
                    <div>
                        <label className="block text-sm font-medium text-gray-600 mb-1">Branch Limit</label>
                        <div className="relative">
                            <input
                                type="text"
                                {...register("storeBrnLimit", { required: true })}
                                onKeyDown={allowOnlyNumbers}
                                placeholder="Enter max number of branches"
                                className={`w-full rounded-md bg-white px-3 py-2 text-sm text-gray-800 border ${errors.storeBrnLimit ? 'border-red-400' : 'border-gray-300'} placeholder:text-gray-400 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition`}
                            />
                        </div>
                        {errors.storeBrnLimit && <p className="mt-1 text-xs text-red-500">Branch limit is required</p>}
                    </div>

                    <div className="pt-2">
                        <button
                            type="submit"
                            className="px-6 py-2 rounded-md bg-blue-500 hover:bg-blue-600 text-sm font-semibold text-white shadow-sm transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500"
                        >
                            Update
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
}

export default StoreInformation;